<script>
    export let toast = undefined;
</script>

<span>
    Impossibile creare l'iscritto.
</span>
